var map = {
	"./portadas_version_escritorio/card_aprovechamiento.jpg": "99e1",
	"./portadas_version_escritorio/card_comunicacion.jpg": "08e3",
	"./portadas_version_escritorio/card_contencion.jpg": "fc7e",
	"./portadas_version_escritorio/card_cooperacion.jpg": "10dd",
	"./portadas_version_escritorio/card_default.jpg": "3eb2",
	"./portadas_version_escritorio/card_impactos.jpg": "4f0c",
	"./portadas_version_escritorio/card_monitoreo.jpg": "8376",
	"./portadas_version_escritorio/card_normatividad.jpg": "3e35",
	"./portadas_version_escritorio/card_origen.jpg": "bec1",
	"./portadas_version_escritorio/card_restauracion.jpg": "62c0",
	"./portadas_version_movil/card_aprovechamiento.jpg": "12af",
	"./portadas_version_movil/card_comunicacion.jpg": "f277",
	"./portadas_version_movil/card_contencion.jpg": "ffa1",
	"./portadas_version_movil/card_cooperacion.jpg": "a002",
	"./portadas_version_movil/card_default.jpg": "2e0b",
	"./portadas_version_movil/card_impactos.jpg": "5e04",
	"./portadas_version_movil/card_monitoreo.jpg": "8522",
	"./portadas_version_movil/card_normatividad.jpg": "b365",
	"./portadas_version_movil/card_origen.jpg": "672c",
	"./portadas_version_movil/card_restauracion.jpg": "3d2f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6742";